import React from 'react';
import Layout from '@/components/layout/Layout';
import Contact from '@/components/home/Contact';

const ContactPage = () => {
  return (
    <Layout>
      <Contact />
    </Layout>
  );
};

export default ContactPage;
